const styles = theme => ({
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    marginTop: 8,
    boxShadow: "none!important"
  }),
  tableheader: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tableheaderlast: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "center"
  },
  tablecontent: {
    fontWeight: "bold",
    color: "black",
    fontSize: "12pt",
    textAlign: "center"
  },
  tablecontent_first: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt",
    textAlign: "left",
    marginTop: '10px',
    marginBottom: '10px'
  },
  tablecontentlast: {
    //fontWeight: "bold",
    color: "black",
    fontSize: "12pt"
  },
  failState: {
    color: theme.palette.fail
  },
  passState: {
    color: theme.palette.success
  },
  div_table: {
    paddingTop: 30,
    height: 380,
    overflow: "auto"
  },
  defaultText: {
    fontSize: "14px"
  },
  tableheader_first: {
    fontWeight: "bold",
    color: "black !important",
    fontSize: "11pt",
    textAlign: "left"
  },
  passedText: {
    color: "#4CAF50",
    fontSize: "14px"
  },
  failedText: {
    color: "#FF5252",
    fontSize: "14px"
  },
  totalGrid: {
    borderRight: "1px solid grey",
    textAlign: "center"
  },
  totalGridLast: {
    textAlign: "center"
  },
  pass: {
    margin: theme.spacing.unit,
    textAlign: "center"
  },
  infoHead: {
    display: "flex",
    margin: "0 Auto",
    width: "80px"
  },
  tablecontent_first_percent: {
    color: "white",
    fontSize: "12pt",
    textAlign: "left",
    backgroundColor: "#32CD32",
    width: '150px',
    marginTop: '10px',
    marginBottom: '10px',
    paddingLeft: '7px'
  },
  table: {
    borderSpacing: '0 5px !important',
  },
  percentage: {
    width: '30px'
  },
});

export default styles;
